
<div class="Section Pricing" id="pricing">
    <div class="SectionHeader">
        <p class="Subtitle">Spezielle Tarife für Ihre Taxi & Mietwagenflotte.</p>
        <h2 class="Headline">Flexible Lösungen</h2>
    </div>
    <div class="PromotionBanner" v-if="showPromotion">
        <div class="PromotionBadge">
            <i class="ri-discount-percent-line"></i>
            <span>{{ discountBadgeText }}</span>
        </div>

        <div class="CTAContent">
            <div class="CTAHeader">
                <div class="CTAIcon">
                    <i class="ri-alarm-warning-fill"></i>
                </div>
                <h3 class="cta-header-text">
                    Sonderaktion: Nur bis {{ promotionDeadlineFormatted }}!
                </h3>
            </div>

            <div class="CTABody">
                <p class="CTAMainText">
                    Sichern Sie sich jetzt
                    <strong>{{ discountPercentage }}% Rabatt auf den Basic Tarif</strong
                    ><span v-if="terminalIncluded">
                        und erhalten Sie das
                        <strong>{{ terminalName }} Terminal kostenlos</strong> dazu</span
                    >! Sparen Sie bei jedem Taxi {{ discountedPrice }}€ pro Monat und
                    profitieren Sie von moderner Zahlungsabwicklung.
                </p>
            </div>

            <div class="PromotionNote">
                Angebot gilt nur für Neukunden • Begrenzte Zeit bis {{ promotionDeadlineShort }}
            </div>
            <div class="CTAAction">
                <router-link to="/register?promotion=true&source=pricing_promotion">
                    <SiteButton>
                        Jetzt {{ discountPercentage }}% sparen & Terminal gratis sichern
                    </SiteButton>
                </router-link>
            </div>
        </div>
    </div>
    <div class="HeaderInfo">
        <p class="TaxInfo">
            <i class="ri-information-line Icon"></i> Alle Preise verstehen sich zzgl. MwSt.
        </p>
    </div>

    <Pricing :planType="currentPlanType" @onUpgrade="handlePlanUpgrade" />

    <div id="promotion-details" class="PromotionText" v-if="showPromotion">
        <p class="PromotionTextHeader">
            <span>* Wichtige Details zur Aktion</span>
        </p>
        <div class="PromotionTextItems">
            <p>
                <strong>Nur für Neukunden</strong> - Dieses Angebot gilt ausschließlich für neue
                TaxiFusion-Kunden
            </p>
            <p>
                <strong>{{ durationMonths }} Monate Aktionspreis</strong> - Der reduzierte Preis
                gilt für die ersten {{ durationMonths }} Monate nach Registrierung
            </p>
            <p>
                <strong>Danach {{ regularPrice }}€/Monat</strong> - Anschließend gilt der
                Standardpreis, abzüglich eventueller Rabatte
            </p>
        </div>
    </div>
</div>
